import { render, staticRenderFns } from "./SuggestedJurisdictionsRadio.vue?vue&type=template&id=73134ecc&scoped=true&"
import script from "./SuggestedJurisdictionsRadio.vue?vue&type=script&lang=js&"
export * from "./SuggestedJurisdictionsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73134ecc",
  null
  
)

export default component.exports